// @flow
import { all } from 'redux-saga/effects';
import appMenuSaga from './appMenu/saga';
import authSaga from './auth/saga';


export default function* rootSaga() {
    yield all([ appMenuSaga(),authSaga()]);
}
